import React from 'react';
import { SxProps } from '@mui/material';
import { Button } from 'system/atoms';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const copyIconSx: SxProps = {
  color: 'primary.main',
  mr: -1,
  ':hover': {
    backgroundColor: 'transparent'
  }
};

interface CopyButtonProps {
  onClick: () => void;
}

export const ConversationCopyButton: React.FC<CopyButtonProps> = ({
  onClick
}) => (
  <Button
    variant="tertiary"
    startIcon={<ContentCopyIcon />}
    onClick={onClick}
    sx={copyIconSx}
  >
    Copy conversation
  </Button>
);
